import type { TOptions } from "i18next";

import { isObject } from "../type-guard";

import type { Tk } from "./translation-key";

type Type =
  | Tk
  | {
      key: Tk;
      options: TOptions;
    };

function toTuple(value: Type) {
  return isObject(value) ? ([value.key, value.options] as const) : ([value] as const);
}

export { toTuple };
export type { Type };
